(function () {
    'use strict';
    angular
        .module('portalApp')
        .factory('YieldCurve', YieldCurve);

    YieldCurve.$inject = ['$resource', 'DateUtils'];

    function YieldCurve($resource, DateUtils) {
        var resourceUrl = 'api/yield-curve/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
